import React, { Component } from "react";
import { Modal, ModalBody, Row, Col, FormGroup, Button } from "reactstrap";
import swal from "sweetalert";
import CustomSpinner from "../../components/CustomSpinner/CustomSpinner";
import GiftCatalogService from "../../services/GiftCatalogService";
import { messages } from "../../constants/constant.message";
import ModalService from "../../services/ModalService";
const { ERROR_MESSAGE } = messages.COMMON;

class BulkUploadRedemptionStatus extends Component {
  defaultFilterControls = {
    controls: {
      selectedFile: {
        value: "",
        valid: null,
        touched: false,
        nullValue: null,
        showErrorMsg: false,
      },
    },
    isLoading: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      controls: JSON.parse(JSON.stringify(this.defaultFilterControls.controls)),
      isLoading: false,
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    const { controls } = this.state;
    controls[name].value = value;
    controls[name].touched = true;
    controls[name].showErrorMsg = false;
    this.setState({
      controls,
      showErrorMsg: false,
    });
  };

  handleUpload = () => {
    this.setState({
      isLoading: true,
    });

    let { controls } = this.state;

    const formData = new FormData();

    if (controls.selectedFile.value) {
      formData.append("file", controls.selectedFile.value);
    }

    GiftCatalogService.bulkUpdateOrderStatus(formData)
      .then((data) => {
        this.setState({
          isLoading: false,
        });

        if (data.data && data.data.data && data.data.data.file) {
          window.open(data.data.data.file, "_blank");
        }
        if (data.data && data.data.message) {
          swal({
            title: "",
            text: data.data.message,
            icon: "success",
            type: "success",
          }).then((value) => {
            controls = JSON.parse(JSON.stringify(this.defaultFilterControls.controls));
            this.setState({ controls });
            this.props.onClose(true);
          });
        }
      })
      .catch((e) => {
        this.setState({
          isLoading: false,
        });
        const err =
          e.response && e.response.data && e.response.data.error
            ? e.response.data.error[0]
            : null;
        const message = err && err.message ? err.message : ERROR_MESSAGE;
        ModalService.openAlert("", message, "warning");
      });
  };

  render() {
    const { controls, isLoading } = this.state;
    const { selectedFile, showErrorMsg } = controls;
    return (
      <Modal
        id="order-track-modal"
        isOpen={this.props.show}
        toggle={this.props.closeModal}
        centered
      >
        <ModalBody>
          {isLoading && <CustomSpinner></CustomSpinner>}
          <Row className="modal-title-border padding-bottom-10">
            <Col className="modal-title">Update Order Status</Col>
          </Row>
          <Row>
            <Col xl="12" md="12" xs="12" className="mt-3">
              <div className="d-flex">
                <FormGroup style={{ marginBottom: "0px", marginTop: "10px" }}>
                  <img
                    style={{ marginLeft: "4px" }}
                    src="images/download.svg"
                    alt=""
                    className="download-report-icon rotateimg180 cursor-pointer margin-left-10"
                  />
                  <label
                    style={{
                      fontWeight: "bold",
                      color: "#5665d8",
                      fontSize: "12px",
                      marginLeft: "10px",
                    }}
                    htmlFor="file"
                  >
                    {selectedFile.value ? selectedFile.value.name : "Choose file"}
                  </label>
                  <input
                    style={{ display: "none" }}
                    id="file"
                    type="file"
                    accept=".xlsx"
                    onChange={(e) =>
                      this.handleInputChange({
                        target: {
                          name: "selectedFile",
                          value: e.target.files[0],
                        },
                      })
                    }
                    className="width-100"
                    ref={(ref) => (this.fileInput = ref)}
                  />
                  {showErrorMsg && (
                    <div className="error">* Please choose file.</div>
                  )}
                </FormGroup>
                <span
                  className="link-warm-blue cursor-pointer"
                  style={{ marginLeft: "10px", marginTop: "10px" }}
                >
                  <a
                    href="https://s3.us-east-1.amazonaws.com/images.jktyrecrm.in/others/Redempton-Order-Status-BulkUpdate.xlsx"
                    target="_blank"
                    rel="noopener noreferrer"
                    download
                    style={{ color: "#5665d8", fontSize: "12px", marginLeft: "10px" }}
                  >
                    <img
                      style={{ marginLeft: "4px" }}
                      src="images/download.svg"
                      alt=""
                      className="download-report-icon cursor-pointer margin-left-10"
                    />
                    <label className="ml-2">Download Sample File</label>
                  </a>
                </span>
              </div>
            </Col>
          </Row>
          <Row className="m-0">
            <Col className="text-align-right mt-4">
              <Button className="mb-1 mr-1 btn-pill action-button profile-cancel-button" color="dark" onClick={() => this.props.onClose()} style={{ width: '86px' }}>
                Close</Button> &nbsp;
              <Button
                type="button"
                className="mb-1 mr-1 btn-pill action-button profile-save-button pull-right"
                color="warning"
                style={{ cursor: 'pointer', width: '86px' }}
                disabled={!selectedFile.value}
                onClick={() => this.handleUpload()}
              >
                Update
              </Button>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    );
  }
}

export default BulkUploadRedemptionStatus;